<template>
  <b-card class="mb-3">

    <b-card-title>Contacts</b-card-title>

    <section v-if="loading">
      <b-spinner class="d-block" variant="primary"></b-spinner>
    </section>

    <section v-else>
      <div class="contacts-table" v-if="contacts && contacts.length > 0">
        <b-table
          hover cy="contacts-table"
          :fields="columns"
          :items="contacts"
          :current-page="currentPage"
          :per-page="perPage"
          :responsive="true"
        >
        </b-table>
      </div>
      <b-row v-if="contacts && contacts.length > 0">
        <b-col md="6" class="my-1">
          <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
        </b-col>
      </b-row>
      <div v-else>
        <p>Visitor has no contacts.</p>
      </div>
    </section>

  </b-card>
</template>

<style></style>

<script>
  import VisitorService from '@/services/VisitorService';
  import {logger} from '@/util/logger';

  export default {
    name: 'visitors-contacts',
    props: {
      visitor_user_id: {
        type: String,
        required: true,
      },
    },
    watch: {
      visitor_user_id() {
        this.getContacts(); // Get new visitor info
      },
    },
    data() {
      return {
        loading: true,
        contacts: [],
        columns: [
          {
            key: 'prisoner_number',
            label: this.$options.filters.term('prison', true) + ' Number',
          },
          {
            key: 'fullName',
            label: 'Name',
          },
          {
            key: 'relationship',
            label: 'Relationship',
          }
        ],
        currentPage: 1,
        perPage: 5,
        totalRows: 0,
      };
    },
    mounted() {
      this.getContacts();
    },
    methods: {
      getContacts() {
        this.loading = true;

        VisitorService.getVisitorContacts(this.visitor_user_id).then(res => {
          if(res.data && res.data.contacts && res.data.contacts.length) {
            this.contacts = res.data.contacts.map((contact) => {
              return {
                fullName: `${contact.prisoner.firstname} ${contact.prisoner.lastname}`,
                ...contact
              };
            });
          }
          this.totalRows = this.contacts.length;
          this.loading = false;
        }).catch(err => {
          logger.error('Error getting visitors contacts', err, {visitorUserId: this.visitorUserId}, 'VisitorsContacts:getContacts');
          this.$toast.error('Error getting users contacts. Please check your connection and refresh the page', {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        });
      }
    }
  };
</script>
